import { FunctionComponent, ReactNode } from 'react';
import classnames from 'classnames';

// Components
import FormGetInfo from '@Pages/home/Components/FAQ/FormGetInfo';
import LayoutContainer from '@Components/Layout/Components/Container';
import FormQuestion from '@Pages/hoi-dap/Components/Asking/FormQuestion';

// Contexts
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Styles
import styles from './LayoutResult.module.scss';
import DownloadApp from '@Pages/bai-viet/Components/DownloadApp';

interface LayoutResultProps {
    className?: string;
    actionPage?: string;
    children?: ReactNode;
    formClassName?: string;
    renderDownloadApp?: any;
    bannerClassName?: string;
    hasFormAdvisory?: boolean;
    advisoryClassName?: string;
    extendComponent?: ReactNode;
    hasExtendComponent?: boolean;
}

const LayoutResult: FunctionComponent<LayoutResultProps> = ({
    children,
    actionPage,
    formClassName,
    extendComponent,
    hasFormAdvisory,
    bannerClassName,
    renderDownloadApp,
    advisoryClassName,
    hasExtendComponent,
    ...props
}) => {
    const { deviceType } = useViewDetected();

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    const bannerClass = classnames([styles.banner_wrapper, bannerClassName]);

    const formClass = classnames([styles.form_wrapper, formClassName]);

    const advisoryClass = classnames([styles.advisory, advisoryClassName]);

    return (
        <LayoutContainer className={className}>
            <div className={styles.content}>{children}</div>

            {/* layout Lists */}
            {hasExtendComponent && actionPage !== 'detail' && (
                <div className={formClass}>
                    <div className={bannerClass}>
                        {extendComponent}
                        {hasFormAdvisory && (
                            <div className={advisoryClass}>
                                <FormGetInfo className={styles.form} />
                            </div>
                        )}
                    </div>
                </div>
            )}
            {/* layout Detail */}
            <ViewMedia is={'desktop'}>
                {actionPage === 'detail' && (
                    <div className={formClass}>
                        <div className={bannerClass}>
                            <FormQuestion active={true} actionPage="detail" />
                            {renderDownloadApp()}
                        </div>
                    </div>
                )}
            </ViewMedia>
        </LayoutContainer>
    );
};

LayoutResult.defaultProps = {
    className: '',
    bannerClassName: '',
    hasExtendComponent: true,
    hasFormAdvisory: true,
    extendComponent: <DownloadApp />,
};

export default LayoutResult;
